module.exports = __webpack_public_path__ + "static/media/Inscription.0091cd95.pdf";